import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

// tslint:disable-next-line:interface-name
export interface DialogData {
    id: string;
    name: string;
    active: boolean;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'delete-location-dialog',
    templateUrl: './delete-location-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class DeleteLocationDialog {
    constructor(
        public dialogRef: MatDialogRef<DeleteLocationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
